import gql from "graphql-tag";

const CELL_FIELDS = `
    id
    cell_type
    background_color
    text_color
    background_color_filter_day
    background_color_filter_day_checked
    text_color_day_filter
    text_color_day_filter_selected
    border_color_selected_day
    font_size_filter_day
    bolder_radius_filter_day
    days_position
    background_color_header
    text_color_header
    background_color_row
    text_color_row
    text_color_first_column
    border_color_table
    font_size_header
    font_size_cell
    columns_count
    column_1_title
    column_2_title
    column_3_title
    column_4_title
    column_5_title
    color_theme
    background_image_uri
    background_fit
    font_family
    days {
        id
        cell_id
        date
    }
    rows {
        id
        cell_id
        agenda_tableau_day_id
        column_1
        column_2
        column_3
        column_4
        column_5
        sort_order
    }
`;

export default {
    get: gql`
    query AgendaTableauCell($id: ID!) {
        agendaTableauCell(id: $id) {
            ${CELL_FIELDS}
        }
    }`,

    update: gql`
    mutation UpdateAgendaTableauCell ($input: UpdateAgendaTableauCellInput!) {
        updateAgendaTableauCell (input: $input) {
            ${CELL_FIELDS}
        }
    }`,

    addDay: gql`
    mutation AddAgendaTableauDay($input: AddAgendaTableauDayInput!) {
        addAgendaTableauDay(input: $input) {
            id
        }
    }`,

    updateDayDate: gql`
    mutation UpdateAgendaTableauDayDate($id: ID!, $date: String!) {
        updateAgendaTableauDayDate(id: $id, date: $date) {
            id
        }
    }`,

    deleteDay: gql`
    mutation DeleteAgendaTableauDay($id: ID!) {
        deleteAgendaTableauDay(id: $id)
    }`,

    addRow: gql`
    mutation AddAgendaTableauRow($input: AddAgendaTableauRowInput!) {
        addAgendaTableauRow(input: $input) {
            id
        }
    }`,

    updateRow: gql`
    mutation UpdateAgendaTableauRow($input: UpdateAgendaTableauRowInput!) {
        updateAgendaTableauRow(input: $input) {
            id
        }
    }`,

    deleteRow: gql`
    mutation DeleteAgendaTableauRow($id: ID!) {
        deleteAgendaTableauRow(id: $id)
    }`,
};
